/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".text-primary[_ngcontent-%COMP%]{color:#1b76bb!important}.btn-primary[_ngcontent-%COMP%]{background-color:#1b76bb;color:#fff}.btn[_ngcontent-%COMP%]{font-weight:500;font-size:16px;border-radius:16px;padding:8px 24px;border:none}.page-apply-review[_ngcontent-%COMP%]   .image-placeholder.photo[_ngcontent-%COMP%]{width:160px}.btn-default[_ngcontent-%COMP%]{background-color:#666;color:#fff}.content-section[_ngcontent-%COMP%]{padding-top:80px;padding-bottom:80px}"];
export { styles as styles };
